import { useState } from 'react';

const useDismissConfirm = () => {
	const [dismissModalVisible, setDismissModalVisible] = useState(false);
	const [idsToDismiss, setIdsToDismiss] = useState<string[]>([]);

	return {
		dismissModalVisible,
		setDismissModalVisible,
		idsToDismiss,
		setIdsToDismiss
	};
};

export default useDismissConfirm;
